/* JouwPilaar: productkaarten van gespoten pilaren wisselen automatisch van kleur.
   Bij hover verschijnt het vooraanzicht van de kleur die op dat moment te zien is.
   De kleurfoto's zijn de slides die het thema al in de kaart zet; de vooraanzichten
   staan in Shopify Files (kaart in assets/rvd-kleuren.json). RVD Allround Services. */
(function () {
  var INTERVAL = 6000, HANDLE = /\/products\/(pilaar-\d+cm)/, SLUG = /(pilaar-\d+cm)-([a-z0-9-]+?)(?:_[0-9a-f-]{36})?\.jpg/;
  var zijkaart = null, zijBelofte = null;

  function zijkanten() {
    if (zijBelofte) return zijBelofte;
    var url = window.rvdKleurenUrl;
    zijBelofte = url ? fetch(url).then(function (r) { return r.json(); }).catch(function () { return {}; }) : Promise.resolve({});
    return zijBelofte.then(function (k) { zijkaart = k; return k; });
  }

  function groot(src) { return src.split('?')[0] + '?width=900'; }

  function maakOverlay(gallery, eerste) {
    gallery.classList.add('rvd-kleurwissel-host');
    var wrap = document.createElement('div'); wrap.className = 'rvd-kleurwissel';
    var a = document.createElement('img'), b = document.createElement('img');
    a.alt = ''; a.className = 'rvd-kleurwissel__img is-zichtbaar'; a.loading = 'eager';
    a.onload = function () { wrap.classList.add('is-klaar'); a.onload = null; };
    a.src = eerste;
    b.alt = ''; b.className = 'rvd-kleurwissel__img'; b.loading = 'lazy';
    wrap.appendChild(a); wrap.appendChild(b); gallery.appendChild(wrap);
    var voor = a, achter = b;
    return function toon(src) {
      if (voor.getAttribute('src') === src) return;
      achter.onload = function () { achter.classList.add('is-zichtbaar'); voor.classList.remove('is-zichtbaar'); var t = voor; voor = achter; achter = t; achter.onload = null; };
      achter.src = src;
    };
  }

  function start(card, volgnummer) {
    var gallery = card.querySelector('.card-gallery'); if (!gallery || gallery.dataset.rvdKleur) return;
    var link = gallery.querySelector('a[href*="/products/"]'); var m = link && HANDLE.exec(link.getAttribute('href')); if (!m) return;
    var handle = m[1];
    var kleuren = [];
    gallery.querySelectorAll('img.product-media__image').forEach(function (img) {
      var s = SLUG.exec(img.getAttribute('src') || img.currentSrc || '');
      if (s && s[1] === handle && s[2] !== 'zij') kleuren.push({ slug: s[2], voor: groot(img.getAttribute('src') || img.currentSrc) });
    });
    if (kleuren.length < 2) return;
    gallery.dataset.rvdKleur = '1';
    var STAPPEN = [7, 11, 13], stap = STAPPEN[volgnummer % 3], idx = 0, hover = false, zichtbaar = true, toon = maakOverlay(gallery, kleuren[0].voor);
    var timer = null;
    function huidigeZij() { return zijkaart && zijkaart[handle + '|' + kleuren[idx].slug]; }
    function tik() { if (hover || document.hidden || !zichtbaar) return; idx = (idx + stap) % kleuren.length; toon(kleuren[idx].voor); }
    function plan() { if (timer) return; timer = setInterval(tik, INTERVAL); }
    gallery.addEventListener('pointerenter', function () { hover = true; gallery.querySelector('.rvd-kleurwissel').classList.add('is-snel'); zijkanten().then(function () { var z = huidigeZij(); if (z && hover) toon(z + '?width=900'); }); });
    gallery.addEventListener('pointerleave', function () { hover = false; toon(kleuren[idx].voor); setTimeout(function () { gallery.querySelector('.rvd-kleurwissel').classList.remove('is-snel'); }, 400); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { zichtbaar = es[0].isIntersecting; }, { threshold: 0.2 }).observe(gallery);
    }
    setTimeout(plan, 1200 + (volgnummer % 3) * 1000);
    zijkanten();
  }

  function init() { document.querySelectorAll('product-card').forEach(start); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  new MutationObserver(function () { init(); }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Kleurkiezer (Globo Color Swatch): 'Kleur' tonen als 'Bibelotte-kleur'. */
(function () {
  function label() {
    document.querySelectorAll('legend.name-option').forEach(function (l) {
      var t = l.firstChild;
      if (t && t.nodeType === 3 && /^\s*Kleur\s*$/.test(t.nodeValue)) t.nodeValue = 'Bibelotte-kleur';
    });
  }
  label(); new MutationObserver(label).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Kleurkiezer: tekstkleur per pil afstemmen op de achtergrondkleur (licht/donker). */
(function () {
  function contrast() {
    document.querySelectorAll('.g-variant-color-detail label.swatch-anchor').forEach(function (l) {
      if (l.dataset.rvdKleur) return;
      var m = /rgb\((\d+),\s*(\d+),\s*(\d+)/.exec(getComputedStyle(l).backgroundColor); if (!m) return;
      var lum = (0.299 * m[1] + 0.587 * m[2] + 0.114 * m[3]) / 255;
      l.style.setProperty('color', lum > 0.6 ? '#3b2419' : '#f0ede8', 'important'); l.dataset.rvdKleur = '1';
    });
  }
  contrast(); new MutationObserver(contrast).observe(document.documentElement, { childList: true, subtree: true });
})();

/* Productpagina gespoten pilaren: vooraanzicht en aanzicht van schuin boven van de gekozen kleur, onder de galerij. */
(function () {
  return; /* vervangen door variant-metafield rvd.aanzichten in de galerij zelf */
  var HANDLE = /\/products\/(pilaar-\d+cm)/, m = HANDLE.exec(location.pathname); if (!m) return;
  var handle = m[1], kaarten = null;
  function laad() {
    if (kaarten) return Promise.resolve(kaarten);
    return Promise.all([window.rvdKleurenUrl, window.rvdKleurenBovenUrl].map(function (u) { return u ? fetch(u).then(function (r) { return r.json(); }).catch(function () { return {}; }) : {}; }))
      .then(function (r) { kaarten = { voor: r[0], boven: r[1] }; return kaarten; });
  }
  function slug(naam) { return naam.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function gekozenKleur() {
    var r = document.querySelector('input[name^="globo-option"]:checked') || document.querySelector('variant-picker input[type="radio"]:checked, .variant-option input[type="radio"]:checked');
    if (r) return r.value;
    var l = document.querySelector('legend.name-option .name-variant'); return l ? l.textContent.replace(/^\s*:\s*/, '').trim() : '';
  }
  function bak() {
    var g = document.querySelector('media-gallery'); if (!g) return null;
    var b = document.querySelector('.rvd-aanzichten');
    if (!b) {
      b = document.createElement('div'); b.className = 'rvd-aanzichten';
      b.innerHTML = '<p class="rvd-aanzichten__kop">Andere aanzichten</p><div class="rvd-aanzichten__rij"><figure><img alt="" loading="lazy"><figcaption>Vooraanzicht</figcaption></figure><figure><img alt="" loading="lazy"><figcaption>Van schuin boven</figcaption></figure></div>';
      g.appendChild(b);
    }
    return b;
  }
  var laatste = '';
  function toon() {
    var kleur = gekozenKleur(); if (!kleur || kleur === laatste) return;
    laad().then(function (k) {
      var key = handle + '|' + slug(kleur), voor = k.voor[key], boven = k.boven[key]; var b = bak(); if (!b) return;
      var imgs = b.querySelectorAll('img'); if (!voor && !boven) { b.hidden = true; return; }
      b.hidden = false; laatste = kleur;
      if (voor) { imgs[0].src = voor + '?width=800'; imgs[0].alt = 'MDF pilaar in de kleur ' + kleur + ', vooraanzicht'; } imgs[0].parentElement.hidden = !voor;
      if (boven) { imgs[1].src = boven + '?width=800'; imgs[1].alt = 'MDF pilaar in de kleur ' + kleur + ', van schuin boven'; } imgs[1].parentElement.hidden = !boven;
    });
  }
  function init() { toon(); document.addEventListener('change', function () { setTimeout(toon, 50); }); new MutationObserver(function () { toon(); }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'aria-selected'] }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
